import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from '@/App';
import { ErrorBoundary } from '@puglieseweb/shared-observability';
import { initSentryEssential } from '@/lib/sentry';
import { initTheme } from '@puglieseweb/shared-react-ui';

// Initialize Sentry before React renders (GDPR essential mode — no consent required)
initSentryEssential();
initTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
